import { render, staticRenderFns } from "./SelecaoFornecedor.vue?vue&type=template&id=30f74f60&"
import script from "./SelecaoFornecedor.vue?vue&type=script&lang=js&"
export * from "./SelecaoFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports